/**
 * Delhi NCR advance-order delivery notice (next-day minimum).
 */
const ADVANCE_ORDER_MESSAGE =
  'Advance order required · Earliest delivery from tomorrow across Delhi NCR';

/** @deprecated Kept for imports that referenced same-day cut-off constants. */
const CUTOFF_HOUR = 14;
const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;

/**
 * @returns {{ beforeCutoff: boolean; hours: number; minutes: number; message: string }}
 */
export function getCutoffStatus() {
  return {
    beforeCutoff: true,
    hours: 0,
    minutes: 0,
    message: ADVANCE_ORDER_MESSAGE,
  };
}

/**
 * @param {Element} root
 */
export function initCutoffCountdown(root = document) {
  root.querySelectorAll('[data-ffp-cutoff-countdown]').forEach((el) => {
    el.textContent = ADVANCE_ORDER_MESSAGE;
  });
}

if (typeof document !== 'undefined') {
  document.addEventListener('DOMContentLoaded', () => initCutoffCountdown());
}

export { CUTOFF_HOUR, IST_OFFSET_MS };
